import { createSelector } from 'reselect';
import { getCategoryDataForType } from '@selectors/data-types-selector';

// Get calendar event category items:
// Additional params dataType
export const getCalendarEventItemsForType = createSelector(
  [getCategoryDataForType],
  items => items
);
